export class CarteiraSelecaoModel {
    id: string;

    nome: string;
}

export class ValidacaoSelecaoModel {

    carteiraNome: string;

    carteiraId: number;

    regraNome: string;

    regraId: number;

    dataInicioAssociacao: Date;

    processamentoOnlineAtivo: boolean = false;
}
